import React from "react";
import { Create, useTranslate } from "react-admin";
import { Flex, Box } from "rebass";
import { useLocation } from "react-router-dom";
import { BetterOrderPOForm, Title, ListButton } from "../components";
import { FooterPOToolbar } from "./components_po";
import { EditFormFields } from "./components_po/promotions";

const ActionForm = (props) => {
  const translate = useTranslate();
  const location = useLocation();
  const { pt = 3 } = props;
  const basepathUrl =
    location.search && location.search === "?i=inventories"
      ? "/inventories"
      : props.basePath;
  return (
    <Flex
      flexDirection={"row"}
      justifyContent={"space-between"}
      width={[1]}
      pt={[pt]}
      pb={[2]}
    >
      <Box width={[1]}>
        <Title fontWeight={"bold"} fontSize={[3]}>
          {translate(props.title)}
        </Title>
      </Box>
      <Flex width={[1]} flexDirection={"row"} justifyContent={"flex-end"}>
        {/* <Button
          color="primary"
          style={{ textTransform: "capitalize", marginRight: 8 }}
          startIcon={<PaperIcon />}
        >
          {translate("resources.buttons.import_from_csv")}
        </Button> */}
        <ListButton basepath={basepathUrl} record={props.data} />
      </Flex>
    </Flex>
  );
};

const initValues = {
  items: [],
  delivery_date: new Date(),
};

const OrdersCreate = (props) => {
  const { hasList, ...rest } = props;

  return (
    <Create {...rest} actions={<ActionForm title={"resources.po.new_po"} />}>
      <BetterOrderPOForm
        {...rest}
        toolbar={<FooterPOToolbar redirect={"/orders"} />}
        typePostUrl={"CREATE"}
        initialValues={initValues}
      >
        <EditFormFields {...rest} typePostUrl={"CREATE"} />
      </BetterOrderPOForm>
    </Create>
  );
};

export default OrdersCreate;
